import { HeatingSystem } from '../domain/types';

export const heatingSystemLabels: Record<HeatingSystem, string> = {
  RADIATORI: 'A radiatori',
  PAVIMENTO: 'A pavimento',
  ARIA: 'Ad aria',
  STUFA: 'A stufa',
};
